import type { Pagination } from "@elit-hair/elit-tools";
import type { DateTime } from "luxon";

import type { PhoneNumberProvider } from "@/types/phone.types";

export const PHONE_NUMBER_IMPORT_INCIDENT_TYPE = "phone-number-import";

export type PhoneNumberImportIncidentData = {
    phoneNumber: string;
    name: string;
    provider: PhoneNumberProvider;
    phoneNumberId?: string;
};

export enum IncidentNotificationType {
    REVIEWING = "incident-reviewing",
}

export type IncidentReviewingNotificationPayload = {
    type: IncidentNotificationType.REVIEWING;
    incidentId: string;
    title: string;
    body: string;
};

export type IncidentReviewingNotification = {
    id: string;
    incidentId: string;
    title: string;
    body: string;
    type: IncidentNotificationType.REVIEWING;
    receivedAt: DateTime;
};

export enum INCIDENT_REPORT_STATUS {
    REPORTED = "REPORTED",
    ASSIGNED = "ASSIGNED",
    RESOLVED = "RESOLVED",
    INVALID = "INVALID",
}

export const INCIDENT_REPORT_STATUS_FILTER = {
    ACTIVE: "ACTIVE",
} as const;

export type IncidentReportStatusFilter = INCIDENT_REPORT_STATUS | (typeof INCIDENT_REPORT_STATUS_FILTER)["ACTIVE"];

export enum INCIDENT_REPORT_PRIORITY {
    LOW = "LOW",
    MEDIUM = "MEDIUM",
    HIGH = "HIGH",
}

export type IncidentReport = {
    id: string;
    userId: string;
    reviewers?: string[];
    status: INCIDENT_REPORT_STATUS;
    description: string;
    priority: INCIDENT_REPORT_PRIORITY;
    type?: string;
    data?: Record<string, unknown>;
    screenshot?: string;
    metadata?: {
        page?: string;
        browser?: string;
        language?: string;
    };
    createdAt: string;
    updatedAt: string;
};

export type IncidentReportFilters = {
    status?: IncidentReportStatusFilter;
    priority?: INCIDENT_REPORT_PRIORITY;
    type?: string;
    userId?: string;
    start?: string;
    end?: string;
} & Partial<Pagination>;

export type IncidentAnalyticsPeriodCount = {
    period: string;
    label: string;
    count: number;
    countExceededMax: boolean;
};

export type IncidentAnalyticsTypeCount = {
    type: string;
    count: number;
    countExceededMax: boolean;
};

export type IncidentAnalytics = {
    byMonth: IncidentAnalyticsPeriodCount[];
    byWeek: IncidentAnalyticsPeriodCount[];
    byType: IncidentAnalyticsTypeCount[];
    total: number;
    totalExceededMax: boolean;
};

export type IncidentAnalyticsFilters = {
    status?: INCIDENT_REPORT_STATUS;
};
